import Vue from 'vue'
import store from '../store/index.js'
import VueRouter from 'vue-router'
import login from '../components/login'
import mainbook from '../components/mainbook'
import branch from '../components/BranchInfo/Branch_List.vue'
import booktype from '../components/Book/BookType_List.vue'
import corp from '../components/CorpInfo/Corp_List.vue'
import err404 from '../components/err404.vue'
import main from '../components/main.vue'
import permission from '../components/permission.vue'
import role from '../components/role.vue'
import user from '../components/usermanage.vue'
import branchbooktype from '../components/Book/Branch_BookType.vue'
import branchbookcapacity from '../components/Book/Branch_Book_Capacity.vue'
import OrderApprove from '../components/Order/OrderApprove.vue'
import SaleModule from '../components/SaleModule/SaleModule_List.vue'
import CheckModule from '../components/CheckModuleInfo/CheckModule_List.vue'
import SaleModuleExplain from '../components/SaleModuleExplain/SaleModuleExplain.vue'
import OrderReport from '../components/Order/OrderReport.vue'
import OrderQuery from '../components/Order/OrderQuery.vue'
import OrderPerson from '../components/Order/OrderPerson.vue'
import SelBookBranch from '../components/Book/SelBookBranch.vue'
import selbookdate from '../components/Book/SelBookDate.vue'
import BookSuccess from '../components/Book/BookSuccess.vue'
import myorder from '../components/Order/MyOrderList.vue'
import ordergroup from '../components/OrderGroup/OrderGroupList.vue'
import ordergroupitem from '../components/OrderGroup/OrderGroupItem.vue'
import ordercusqy from '../components/OrderCus/OrderCus.vue'
import ordercus from '../components/OrderCus/OrderCus.vue'
import loginbook from '../components/loginbook.vue'
import showrpt from '../components/showreport.vue'
import mainclient from '../components/mainclient.vue'
import OrderBookList from '../components/OrderCus/OrderBookList.vue'
import OrderCheck from '../components/OrderCus/OrderCheck.vue'
import BookCusList from '../components/BookCus/BookCusList.vue'
import BookedCusList from '../components/BookCus/BookedCusList.vue'
import BookForOrderCus from '../components/BookCus/BookForOrderCus.vue'
import BookGroupSel from '../components/BookCus/ShowBookGroup.vue'
import BookGroupAddSel from '../components/BookCus/ShowBookGroupAdd.vue'
import BookForSingle from '../components/BookCus/BookForSingle.vue'
import HistoryReport from '../components/Member/HistoryReport.vue'
import ShowCusPay from '../components/BookCus/ShowCusPay.vue'
import goodstype from '../components/Goods/GoodsTypeList.vue'
import goods from '../components/Goods/GoodsList.vue'
import goodsitem from '../components/Goods/GoodsItem.vue'
import goodsmain from '../components/Goods/GoodsMain.vue'
import PayMOrder from '../components/Member/PayMOrder.vue'
import MOrderList from '../components/Member/MOrderList.vue'
import orderbookdetail from '../components/OrderCus/OrderCusBookDetail.vue'
import Branch_Book_Detail from '../components/BookCus/Branch_Book_Detail.vue'
Vue.use(VueRouter)
const routes = [{
		path: '*',
		component: loginbook

	},
	{
		path: "/loginbook",
		name: "loginbook",
		component: loginbook
	},

	{
		path: "/mainclient",
		name: "mainclient",
		component: mainclient,
		children: [{
				path: "/OrderBookList",
				name: "OrderBookList",
				component: OrderBookList,
			},
			{
				path: "/OrderCheck",
				name: "OrderCheck",
				component: OrderCheck,
			},
			{
				path: "/ordercusqy",
				name: "ordercusqy",
				component: ordercusqy
			},
		]
	},

	{
		path: "/mainbook",
		name: "mainbook",
		component: mainbook,
		children: [
			{
				path: "/BookCusList",
				name: "BookCusList",
				component: BookCusList
			},
			{
				path: "/BookedCusList",
				name: "BookedCusList",
				component: BookedCusList
			},
			{
				path: "/BookForOrderCus",
				name: "BookForOrderCus",
				component: BookForOrderCus
			},
			{
				path: "/BookGroupSel",
				name: "BookGroupSel",
				component: BookGroupSel
			},
			{
				path: "/BookGroupAddSel",
				name: "BookGroupAddSel",
				component: BookGroupAddSel
			},
			{
				path: "/BookForSingle",
				name: "BookForSingle",
				component: BookForSingle
			},
			{
				path: "/HistoryReport",
				name: "HistoryReport",
				component: HistoryReport
			},
			{
				path: "/ShowCusPay",
				name: "ShowCusPay",
				component: ShowCusPay
			},
			{
				path: "/SelBookBranch",
				name: "SelBookBranch",
				component: SelBookBranch,
				// children: [
				// ]
			},
			{
					path: "/selbookdate",
					name: "selbookdate",
					component: selbookdate
				},
				{
					path: "/BookSuccess",
					name: "BookSuccess",
					component: BookSuccess
				},
			{
				path: "/goodsmain",
				name: "goodsmain",
				component: goodsmain
			},
			{
				path: "/PayMOrder",
				name: "PayMOrder",
				component: PayMOrder
			},
			{
				path: "/MOrderList",
				name: "MOrderList",
				component: MOrderList
			},
			
			
		]
	},
	{
		path: "/login",
		name: "login",
		component: login
	},
	{
		path: "/showrpt",
		name: "showrpt",
		component: showrpt
	},
	{
		path: "/err404",
		name: "err404",
		component: err404
	},
	{
		path: "/main",
		name: "main",
		component: main,
		children: [{
				path: "/goodstype",
				name: "goodstype",
				component: goodstype
			},
			{
				path: "/goods",
				name: "goods",
				component: goods
			},
			{
				path: "/goodsitem",
				name: "goodsitem",
				component: goodsitem
			},
			{
				path: "/myorder",
				name: "myorder",
				component: myorder
			},
			{
				path: "/ordergroup",
				name: "ordergroup",
				component: ordergroup,
				children: [{
					path: "/ordergroupitem",
					name: "ordergroupitem",
					component: ordergroupitem
				}]
			},
			{
				path: "/ordercus",
				name: "ordercus",
				component: ordercus
			},
			{
				path: "/orderbookdetail",
				name: "orderbookdetail",
				component: orderbookdetail
			},
			{
				path: "/permission",
				name: "permission",
				component: permission
			},
			{
				path: "/role",
				name: "role",
				component: role
			},
			{
				path: "/user",
				name: "user",
				component: user
			},
			{
				path: "/branch",
				name: "branch",
				component: branch
			},
			{
				path: "/booktype",
				name: "booktype",
				component: booktype
			},
			{
				path: "/corp",
				name: "corp",
				component: corp
			},
			{
				path: "/branchbooktype",
				name: "branchbooktype",
				component: branchbooktype
			},
			{
				path: "/branchbookcapacity",
				name: "branchbookcapacity",
				component: branchbookcapacity
			},
			{
				path: "/Branch_Book_Detail",
				name: "Branch_Book_Detail",
				component: Branch_Book_Detail
			},
			
			{
				path: "/OrderApprove",
				name: "OrderApprove",
				component: OrderApprove,
				children: [{
					path: "/OrderReport",
					name: "OrderReport",
					component: OrderReport

				}]

			},
			{
				path: "/OrderQuery",
				name: "OrderQuery",
				component: OrderQuery,
				children: [

					{
						path: "/OrderPerson",
						name: "OrderPerson",
						component: OrderPerson

					},
					{
						path: "/OrderReportQ",
						name: "OrderReportQ",
						component: OrderReport

					}
				]
			},
			{
				path: "/SaleModule",
				name: "SaleModule",
				component: SaleModule
			},
			{
				path: "/CheckModule",
				name: "CheckModule",
				component: CheckModule
			},
			{
				path: "/SaleModuleExplain",
				name: "SaleModuleExplain",
				component: SaleModuleExplain
			}
		]
	}

	// {
	//     path: '/', 
	//     redirect: '/login' 
	// },
]

var router = new VueRouter({
	routes
});
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
	if (to.path === '/loginbook') {
		next();
	} else {
		let token = localStorage.getItem('token');

		if (token === 'null' || token === '') {
			next('/loginbook');
		} else {
			next();
		}
	}
});

export default router;
